import { SegmentEventType } from 'api';

export enum Events {
  ShareInitiated = 'Share Initiated',
  ShareCompleted = 'Share Completed',
  ClickPostDiscussion = 'click_post_discussion',
  ClickMenuDiscussion = 'click_menu_discussion',
  DiscussionViewed = 'discussion_viewed',
  DiscussionSubscribed = 'discussion_subscribed',
  CommentUnique = 'comment_unique',
  ClickCommentCount = 'click_comment_count',
  ClickLikeCount = 'click_like_count',
  ClickShareCount = 'click_share_count',
  ClickEngage = 'click_engage',
  PublicPostImpression = 'Public Post Impression',
  PublicPostShareInitiated = 'Public Post Share Initiated',
  PublicPostShareCompleted = 'Public Post Share Completed',
  PublicPostEngageClicked = 'Public Post Engage Clicked',
  PublicPostClicked = 'Public Post Clicked',
  PublicPostLogoClicked = 'Public Post Logo_Clicked',
  PostReadMoreClicked = 'Post Read More Clicked',
  RepostClicked = 'Repost Clicked',
  FormSubmitted = 'Form Submitted',
}

export enum FunnelEvent {
  SLEULCS = SegmentEventType.SignupLoginExistingUserLoginClientSelected,
  SLEUCCCC = SegmentEventType.SignupLoginExistingUserCreateClientClientCreated,
  SLEUCCCMCG = SegmentEventType.SignupLoginExistingUserCreateClientClientModifiedCreateGroups,
  SLEUCCCMIC = SegmentEventType.SignupLoginExistingUserCreateClientClientModifiedInviteColleagues,
  SLNUCCCC = SegmentEventType.SignupLoginNewUserCreateClientClientCreated,
  SLNUCCCMCG = SegmentEventType.SignupLoginNewUserCreateClientClientModifiedCreateGroups,
  SLNUCCCMIC = SegmentEventType.SignupLoginNewUserCreateClientClientModifiedInviteColleagues,
  SLNUSUMCU = SegmentEventType.SignupLoginNewUserSignupClientUserModifiedCreateUser,
  SLNUSUMDL = SegmentEventType.SignupLoginNewUserSignupClientUserModifiedSelectDeptloc,
  SLNUSUMCN = SegmentEventType.SignupLoginNewUserSignupClientUserModifiedConnectNetwork,
}
